import { ReactElement } from 'react';

import RichText from 'components/UI/Richtext';
import NavLink from 'components/UI/Nav/NavLink';
import { IComponentDoctorSpecialtyLinksFields } from 'types/contentful';

export type DoctorSpecialtyLinkItem = {
  id: string;
  service: string;
  slug: string;
};

export type DoctorSpecialtyLinksProps = IComponentDoctorSpecialtyLinksFields & {
  items?: DoctorSpecialtyLinkItem[];
};

function splitIntoColumns<T>(items: T[]): T[][] {
  const mid = Math.ceil(items.length / 2);
  return [items.slice(0, mid), items.slice(mid)];
}

export default function DoctorSpecialtyLinks({
  id,
  heading,
  items = [],
}: DoctorSpecialtyLinksProps): ReactElement {
  const columns = splitIntoColumns(items);

  return (
    <div id={id} className="px-site-component pb-10 md:pb-20 text-primary-actual">
      {heading && (
        <div className="font-heading text-new-34 lg:text-4xl lg:leading-new-43 text-primary-actual text-center">
          <RichText document={heading} />
        </div>
      )}
      {items.length > 0 && (
        <div className="gap-x-8 grid grid-cols-1 justify-self-center md:gap-x-16 md:grid-cols-2 mt-6">
          {columns.map((columnItems, colIndex) =>
            columnItems.length > 0 ? (
              <ul key={colIndex} className="list-disc pl-5 m-0 space-y-2">
                {columnItems.map((item) => (
                  <li key={item.id}>
                    <NavLink
                      slug={`/doctors/optometrists/${item.slug.replace(/^\/+/, '')}`}
                      text={item.service}
                      classNames="text-lg text-tertiary-actual underline hover:text-primary-actual"
                      currentSlug="/"
                    />
                  </li>
                ))}
              </ul>
            ) : null
          )}
        </div>
      )}
    </div>
  );
}
